import { useState } from 'react'

import { Log } from 'services/apiTypes/deck.types'
import { defaultCard } from 'types/deck'

import CursorCardWrapper from 'components/card/CursorCardWrapper'
import Image from 'components/elements/Image'
import Link from 'components/elements/Link'

import { generateHumanLog } from 'components/deckPage/deckHistory/recentChanges.utils'
import { timeSince } from 'utils/time.utils'
import { encodeUsernameRoute } from 'utils/encoding'

import styles from './recentChangeRow.module.scss'

type Props = {
  log: Log
}

const RecentChangeRow = ({ log }: Props) => {
  const [showMore, setShowMore] = useState(false)

  const humanLogs = generateHumanLog(log.data, log.action, log.card)
  const createdAtDate = new Date(log.createdAt)

  return (
    <CursorCardWrapper className={styles.container} card={log.card || defaultCard}>
      <div className={styles.row}>
        {/* Avatar duplicated here and below, for easier markup (hidden on mobile) */}
        <Image className={styles.desktopAvatar} src={log.updatedBy.avatar} alt={`${log.updatedBy.username}-avatar`} />
        <div className={styles.content}>
          <div className={styles.cardName}>{log.card?.name || 'Unknown'}</div>
          <div className={styles.changes}>
            {log.action === 'add' && <span className={styles.add}>Added</span>}
            {log.action === 'modify' && <span className={styles.modify}>Modified</span>}
            {log.action === 'remove' && <span className={styles.remove}>Removed</span>}
            {humanLogs[0]} by&nbsp;
            <Link className={styles.link} href={`/u/${encodeUsernameRoute(log.updatedBy.username)}`}>
              {log.updatedBy.username}
            </Link>
          </div>
          {showMore && (
            <div className={styles.changes}>
              {humanLogs.map((log, index) => {
                if (index === 0) return null

                return (
                  <div className={styles.changes}>
                    <span className={styles.modify}>Modified</span> {log}
                  </div>
                )
              })}
            </div>
          )}
          {humanLogs.length > 1 && (
            <div>
              <button className={styles.showMore} onClick={() => setShowMore(!showMore)}>
                {!showMore && `(And ${humanLogs.length - 1} More)`}
                {showMore && 'Show Less'}
              </button>
            </div>
          )}
        </div>
      </div>
      <div>
        {/* Avatar duplicated here and above, for easier markup (hidden on desktop) */}
        <Image className={styles.mobileAvatar} src={log.updatedBy.avatar} alt={`${log.updatedBy.username}-avatar`} />
        <div
          className={styles.time}
          title={`${createdAtDate.toLocaleDateString()} ${createdAtDate.toLocaleTimeString()}`}>
          {timeSince(log.createdAt)}
        </div>
      </div>
    </CursorCardWrapper>
  )
}

export default RecentChangeRow
